
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[athleteSlug]/streams/[streamSlug]",
      function () {
        return require("private-next-pages/[athleteSlug]/streams/[streamSlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[athleteSlug]/streams/[streamSlug]"])
      });
    }
  